(() => {
  const init = (card) => {
    if (!card || card.__kowiInit) return;
    card.__kowiInit = true;

    const track = card.querySelector(".card-545__track");
    const slides = card.querySelectorAll(".card-545__slide");
    const prev = card.querySelector(".card-545__nav--prev");
    const next = card.querySelector(".card-545__nav--next");
    const progress = card.querySelector(".card-545__progress span");

    if (!track || slides.length <= 1) {
      card.classList.add("is-single");
      return;
    }

    const animateScrollTo = (targetLeft, duration = 420) => {
      const startLeft = track.scrollLeft;
      const distance = targetLeft - startLeft;
      const startTime = performance.now();

      const easeInOutCubic = (t) =>
        t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;

      const step = (now) => {
        if (!track.isConnected) return;
        const elapsed = now - startTime;
        const progress = Math.min(1, elapsed / duration);
        const eased = easeInOutCubic(progress);
        track.scrollLeft = startLeft + distance * eased;
        if (progress < 1) requestAnimationFrame(step);
      };

      requestAnimationFrame(step);
    };

    const scrollToIndex = (index, opts = {}) => {
      const slide = slides[index];
      if (!slide) return;
      if (opts.duration) {
        animateScrollTo(slide.offsetLeft, opts.duration);
        return;
      }
      track.scrollTo({ left: slide.offsetLeft, behavior: "smooth" });
    };

    const currentIndex = () => {
      const width = track.clientWidth;
      if (!width) return 0;
      return Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / width)));
    };

    const updateArrows = () => {
      const index = currentIndex();
      if (prev) {
        const disabledPrev = index <= 0;
        prev.classList.toggle("is-disabled", disabledPrev);
        prev.toggleAttribute("disabled", disabledPrev);
        prev.setAttribute("aria-disabled", disabledPrev ? "true" : "false");
      }
      if (next) {
        const disabledNext = index >= slides.length - 1;
        next.classList.toggle("is-disabled", disabledNext);
        next.toggleAttribute("disabled", disabledNext);
        next.setAttribute("aria-disabled", disabledNext ? "true" : "false");
      }
    };

    prev?.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (prev.classList.contains("is-disabled")) return;
      scrollToIndex(Math.max(0, currentIndex() - 1));
    });

    next?.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (next.classList.contains("is-disabled")) return;
      scrollToIndex(Math.min(slides.length - 1, currentIndex() + 1));
    });

    const hoverQuery = window.matchMedia("(min-width: 990px)");
    let hoverTimer;
    const onHoverEnter = () => {
      if (!hoverQuery.matches) return;
      card.classList.add("is-hover");
      window.clearTimeout(hoverTimer);
      hoverTimer = window.setTimeout(() => {
        scrollToIndex(1, { duration: 520 });
      }, 120);
    };
    const onHoverLeave = () => {
      if (!hoverQuery.matches) return;
      card.classList.remove("is-hover");
      window.clearTimeout(hoverTimer);
      scrollToIndex(0, { duration: 520 });
    };
    card.addEventListener("mouseenter", onHoverEnter);
    card.addEventListener("mouseleave", onHoverLeave);

    let hideTimer;
    const updateProgress = () => {
      if (!progress) return;
      const index = currentIndex();
      const pct = (index + 1) / slides.length;
      progress.style.transform = `scaleX(${pct})`;
    };

    const showBar = () => {
      card.classList.add("is-scrolling");
      window.clearTimeout(hideTimer);
      hideTimer = window.setTimeout(() => card.classList.remove("is-scrolling"), 900);
    };

    track.addEventListener("scroll", () => {
      updateProgress();
      updateArrows();
      showBar();
    }, { passive: true });

    updateProgress();
    updateArrows();
  };

  let initFrame = null;
  const initAll = (root = document) => {
    const cards = [];
    if (root.matches?.(".card-545")) cards.push(root);
    root.querySelectorAll?.(".card-545").forEach((card) => cards.push(card));
    cards.forEach(init);
  };

  const scheduleInit = (root = document) => {
    if (initFrame) cancelAnimationFrame(initFrame);
    initFrame = requestAnimationFrame(() => {
      initFrame = null;
      initAll(root);
    });
  };

  const nodeHasCards = (node) => {
    if (!node || node.nodeType !== Node.ELEMENT_NODE) return false;
    return node.matches?.(".card-545, #ProductGridContainer") || !!node.querySelector?.(".card-545");
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (nodeHasCards(node)) {
          scheduleInit(node);
          return;
        }
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  document.addEventListener("facets:rendered", () => {
    scheduleInit(document.getElementById("ProductGridContainer") || document);
  });
})();
